import { ref, computed, watch } from 'vue'
import store from '@/store'
import {
  PLACE_RELATIONSHIP,
  STILL_DAYS_OPERATOR,
  CONDITION_AVAILABLE_FUNCTION_TYPE,
} from '@/composables/member/UseUserStatusFilterCondition'
export {
  PLACE_RELATIONSHIP,
  STILL_DAYS_OPERATOR,
  CONDITION_AVAILABLE_FUNCTION_TYPE,
}

/**
 * 空の絞り込み条件取得
 * @returns {Object} 空の絞り込み条件
 */
const getBlankCondition = () => ({
  // ユーザータイプ
  userType: {
    target: null,
  },
  // キーワード検索条件
  search: {
    // キーワード
    keyword: null,
    // キーワード検索対象項目
    keywordTargets: [],
  },
  // グループ条件
  organization: {
    // 組織グループID
    organizationIds: null,
  },
  // 屋内条件
  indoor: {
    // サイトID
    indoorSiteIds: null,
    // ビルID
    indoorBuildingIds: null,
    // フロアID
    indoorLevelId: null,
  },
  // プレイス条件
  place: {
    // プレイスID
    placeId: null,
    // 対象プレイスとの関係性
    relationship: PLACE_RELATIONSHIP.IS,
    // プレイスからの距離(m)
    distance: null,
  },
  // ステイタス条件
  status: {
    // ステイタス種別ID
    statusTypeId: null,
  },
  // アクティビティ条件
  activity: {
    // 停止中のみの場合はtrue
    isStill: null,
    // 停止日数を指定可能な場合はtrue
    canSetDays: false,
    // 停止期間(日)
    stillDays: null,
    // 停止期間演算子(ge: 以上, le: 以内)
    stillDaysOperator: null,
  },
  // 測位状態条件
  positioning: {
    // 測位中のみの場合はtrue null はすべて扱い
    isPositioning: null,
  },
})

/**
 * ユーザーリストの絞り込み条件の管理
 */
export const useUserListFilterCondition = () => {
  /**
   * 絞り込み条件
   * @type {Ref.<Object>}
   */
  const condition = ref(getBlankCondition())

  /**
   * 何らかの条件が設定されている場合はtrue
   * @type {ComputedRef.<boolean>}
   */
  const isSomeConditionSet = computed(
    () =>
      JSON.stringify(condition.value) !== JSON.stringify(getBlankCondition())
  )

  /**
   * condition を更新する
   * @param {Object} value 更新値
   */
  const updateCondition = (value) => {
    for (const [k, v] of Object.entries(value)) {
      if (k in condition.value) {
        condition.value[k] = {
          ...condition.value[k],
          ...v,
        }
      }
    }
  }

  // 変更を store に反映
  // 中身の変更の無い shallow copy のみの変更を省くため文字列化して watch
  watch(
    () => JSON.stringify(condition.value),
    () => {
      store.commit('updateUserListState', { condition: condition.value })
    }
  )

  /**
   * 初期絞り込み条件設定
   */
  // store の状態反映
  updateCondition(store.state.userList.condition)
  // キーワード検索対象は対応した store の値を使用
  condition.value.search.keywordTargets =
    store.getters['userKeywordTarget/keywordTargets']

  return {
    condition,
    isSomeConditionSet,
    updateCondition,
    getBlankCondition,
  }
}
